import { Box, Drawer } from "@mui/material";
import { DEFAULT_ELEVATION } from "lib/global";
import { DEFAULT_DRAWER_WIDTH } from "lib/global";
import React, { useEffect } from "react";
import SideBarContent from "./SideBarContent";

export default function SideBar({ open = false, ...props }) {
  const { window } = props;
  const container = window?.document?.body ?? undefined;

  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  useEffect(() => {
    setMobileOpen(open);
  }, [open]);

  return (
    <Box
      component="nav"
      sx={{ width: { lg: DEFAULT_DRAWER_WIDTH }, flexShrink: { lg: 0 } }}
      aria-label="mailbox folders"
    >
      {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
      <Drawer
        container={container}
        variant="temporary"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        ModalProps={{
          keepMounted: true, // Better open performance on mobile.
        }}
        sx={{
          display: { md: "block", lg: "none" },
          "& .MuiDrawer-paper": {
            boxSizing: "border-box",
            width: DEFAULT_DRAWER_WIDTH,
          },
        }}
        elevation={DEFAULT_ELEVATION}
      >
        <SideBarContent />
      </Drawer>
      <Drawer
        variant="permanent"
        sx={{
          display: { md: "none", lg: "block" },
          "& .MuiDrawer-paper": {
            boxSizing: "border-box",
            width: DEFAULT_DRAWER_WIDTH,
          },
        }}
        open
        elevation={DEFAULT_ELEVATION}
      >
        <SideBarContent />
      </Drawer>
    </Box>
  );
}
